__turbopack_context__.v({
  "closeButton": "style-module-scss-module__8SKaFG__closeButton",
  "container": "style-module-scss-module__8SKaFG__container",
  "contentLayer": "style-module-scss-module__8SKaFG__contentLayer",
  "headerContainer": "style-module-scss-module__8SKaFG__headerContainer",
  "playButton": "style-module-scss-module__8SKaFG__playButton",
  "playButtonContainer": "style-module-scss-module__8SKaFG__playButtonContainer",
  "textContainer": "style-module-scss-module__8SKaFG__textContainer",
  "videoBackground": "style-module-scss-module__8SKaFG__videoBackground",
  "videoOverlay": "style-module-scss-module__8SKaFG__videoOverlay",
});
